<template>
    <main>
        <div class="container-fluid">
            <div class="row">
                <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="mainButton">
                        <breadcrumbs></breadcrumbs>
                    </div>
                    <div class="page-toolbar">
                        <div class="page-title"><span class="title">User Dashlet</span>
                            <span class="star"> <i class="fa-solid fa-star"></i></span>
                        </div>
                        <div class="page-create-button">
                            <router-link to="/modules/userdashlets/edit" class="btn-create">Create</router-link>
                        </div>
                        <div class="page-filter">
                            <input type="search" value="" placeholder="Searching..." class="form-control"
                                v-on:click="openAction">
                            <CustomSearch v-bind:class="{ active: isActive }" @searchEvent="childMethod"
                                @openAction="openAction"></CustomSearch>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <GenericList v-if="generic" ref="loadGeneric"></GenericList>
        <CustomList v-else ref="loadCustom"></CustomList>
    </main>
</template>



<script>
    import { ref } from "vue";
    import breadcrumbs from "@/views/modules/UserDashlets/MenuList.vue";
    import lang from "@/views/modules/UserDashlets/language/en";
    import GenericList from "@/components/layout/shared/generic/ListView.vue";
    import CustomList from "@/views/modules/UserDashlets/ListView.vue";
    import CustomSearch from "@/views/modules/UserDashlets/SearchView.vue";

    export default {
        name: "list-userdashlet",
        components: {
            breadcrumbs,
            GenericList,
            CustomList,
            CustomSearch,
        },
        data() {
            return {
                generic: true,
                isActive: false,
                metaList: [
                    {
                        label: lang.LBL_NAME,
                        link: true,
                        moduleName: 'UserDashlets',/// moduleName is required
                        routePath: 'userdashlets',/// routePath is required at start of object
                        isSort:true,
                        field_name:'name',
                    },
                    {
                        label: lang.LBL_MODULE_DASHLETS,
                        link: true,
                        routePath: 'userdashlets',/// routePath is required at start of object
                        isSort:true,
                        field_name:'description',
                    },
                    {
                        label: lang.LBL_USER_TYPE,
                        link: true,
                        routePath: 'userdashlets',/// routePath is required at start of object
                        isSort:true,
                        field_name:'user_type',
                    },
                ],
                columns: ['name', 'description', 'user_type'],

            }
        },
        mounted() {
            this.childMethod();
            //this.$emit('MetaView','Awesome')
            let user = JSON.parse(localStorage.getItem('user_prefrence'));
            
        },
        methods: {
            childMethod(search = '') {
                if (this.generic == true) {
                    this.$refs.loadGeneric.loadGenericView(this.metaList, this.columns, search);
                } else {
                    if (search != '') {
                        this.$refs.loadCustom.getProducts(search);
                    }
                }
            },

            openAction() {
                this.isActive = !this.isActive;
            },
        }
    }

</script>